import Vue from 'vue';
import axios from 'axios';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
import router from '../router/router';
import { resolve } from 'path';
import { stat } from 'fs';

import styleDefault from '../consts/styleFields';
import styleOptions from '../consts/styleOptions';
import fitDefault from '../consts/fitFields';

Vue.use(Vuex);

const vuexLocalStorage = new VuexPersist({
  key: 'trvl_porter_frontend_vuex', // The key to store the state on in the storage provider.
  storage: window.localStorage      // or window.sessionStorage or localStorage
});

const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL
});
http.interceptors.request.use(
  (config) => {
		if(store.state.access_token) config.headers['Authorization'] = 'Basic ' + btoa(store.state.access_token + ':*');
    return config;
  }, 

  (error) => {
    return Promise.reject(error);
  }
);

const cache = {
	orders: {},
	lookbooks: {}
};

const wizardNavigator = {
	show: false,
	progressStep: 'trip',
	hasLookbook: false,
	styleFirst: false,
	showSizeAndStyle: true,
	nextDisabled: true,
	prevDisabled: true,
	itemsRemaining: 0
}


const store = new Vuex.Store({
	plugins: [vuexLocalStorage.plugin],
	state: {
		loading: true,
		access_token: false,
    user: {
			updated: 0,
			data: {}
		},
		referred_by: null,
		oauth_redirect: null,
		/*style: {
			updated: 0,
			data: JSON.parse(JSON.stringify(styleDefault))
		},
		fit: {
			updated: 0,
			data: JSON.parse(JSON.stringify(fitDefault))
		},*/
		cache: JSON.parse(JSON.stringify(cache)),
		wizardNavigator: JSON.parse(JSON.stringify(wizardNavigator)),
	},
	getters: {
		user: function(state, getters) {
			return (state.user.data.id ? state.user.data : false);
		},
		style: function(state, getters) {
			return (getters.user && !Array.isArray(getters.user.style) ? getters.user.style : {});
		},
		fit: function(state, getters) {
			return (getters.user && !Array.isArray(getters.user.fit) ? getters.user.fit : {});
		},
		isAuthorized: function(state, getters) {
			return (state.access_token && getters.user ? true : false);
		},
		isAdmin: function(state, getters) {
			return (getters.user && getters.user.role == 'admin');
		},
		isStylist: function(state, getters) {
			return (getters.isAdmin || (getters.user && getters.user.role == 'stylist'));
		},
		isLoading: function(state, getters) {
			return state.loading;
		},
		wizardNavigator: function(state, getters) {
			return state.wizardNavigator;
		},

		orderFromCache: function(state, getters) {
			return function(order_id) {
				if(state.cache.orders[ order_id ]) {
					let order = state.cache.orders[ order_id ];
					//Order object in cache is valid for 10 minutes
					if(order.updated && (order.updated + 600000) > Date.now()) {
						return order.data;
					} else {
						return null;
					}
				} else {
					return null;
				}
			}
		},
		lookbookFromCache: function(state, getters) {
			return function(lookbook_id) {
				if(state.cache.lookbooks[ lookbook_id ]) {
					let lookbook = state.cache.lookbooks[ lookbook_id ];
					//Lookbook object in cache is valid for 10 minutes
					if(lookbook.updated && (lookbook.updated + 600000) > Date.now()) {
						return lookbook.data;
					} else {
						return null;
					}
				} else {
					return null;
				}
			}
		},

		fitStep: function(state, getters) {
			let fit = getters.fit;
			let step = 'height';
			if(!fit.height_ft || !fit.height_in) return step;
			
			step = 'top';
			if(!fit.top_size) return step;
			
			step = 'dress';
			if(!fit.dress_size) return step;
			
			step = 'jean';
			if(!fit.denim_waist_size) return step;
			
			step = 'pants';
			if(!fit.pant_size) return step;
			
			step = 'bra';
			if(!fit.bra_size || !fit.bra_cup_size) return step;
			
			step = 'body';
			if(!fit.body_shape) return step;
			
			step = 'birthday';
			return step;
		},
		hasFit: function(state, getters) {
			let step = getters.fitStep;
			return (step == 'birthday');
		},
		
		styleStep: function(state, getters) {

			let style = getters.style;
			let step = 'current_style';
			if( !style.current_style || !style.current_style.length ) return step;
			
			step = 'necklines_preferred';
			if( !style.necklines || !style.necklines.length ) return step;
			
			step = 'top_half_fit';
			if( !style.top_half_fit || !style.top_half_fit.length ) return step;
			
			step = 'sleeve_preference';
			if( !style.sleeve_preference || !style.sleeve_preference.length ) return step;
			
			step = 'pant_fit';
			if( !style.pant_fit || !style.pant_fit.length ) return step;
			
			step = 'dress_style';
			if( !style.dress_style || !style.dress_style.length ) return step;
			
			step = 'areas_conceal';
			return step;
		},
		hasStyle: function(state, getters) {
			let step = getters.styleStep;
			return (step == 'areas_conceal');
		},
		referredBy: function(state) {
			if(state.referred_by) {
				let arr = state.referred_by.split('+');
				if(Date.now() < parseInt(arr[1])) {
					return arr[0];
				}
			}
			return null;
		},
		oauthRedirect: function(state) {
			return state.oauth_redirect;
		}

	},
	actions: {
		startLoading ( context ) {
			context.commit('setLoading', true);
		},
		stopLoading ( context ) {
			context.commit('setLoading', false);
		},
		wizardShow ( context ) {
			context.commit('setWizardVisible', true);
		},
		wizardHide ( context ) {
			context.commit('setWizardVisible', false);
		},
		wizardEnableNext ( context ) {
			context.commit('setWizardNextDisabled', false);
		},
		wizardDisableNext ( context ) {
			context.commit('setWizardNextDisabled', true);
		},
		wizardEnablePrev ( context ) {
			context.commit('setWizardPrevDisabled', false);
		},
		wizardDisablePrev ( context ) {
			context.commit('setWizardPrevDisabled', true);
		},
		deauthorize ( context ) {
			if(context.state.access_token) {
				http.delete('auth')
					.then(response => {
						context.commit('updateAccessToken', false);
					})
					.catch(error => {
						if(error.response.status == 401) context.commit('updateAccessToken', false);
					});
			} else {
				context.commit('updateAccessToken', false);
			}
			context.commit('setUser', false);
			context.commit('resetCaches');
			context.dispatch('stopLoading');
			if(!context.state.route.meta.noauth) router.push({name:'auth'});
		},
		checkForUpdates ( context ) {
      context.dispatch('startLoading');
      
			//Need to call this to make sure headers are set.
			context.commit('updateAccessToken', context.state.access_token);
      
      if(context.getters.user) {
				
				//Check for style updates if update was more than 5 minutes ago
				/*if( (context.state.style.updated + 300000) < Date.now() ) {
					context.dispatch('checkForStyleUpdates').catch(error => {});
				}*/

				//Check for Fit updates if update was more than 5 minutes ago
				/*if( (context.state.fit.updated + 300000) < Date.now() ) {
					context.dispatch('checkForFitUpdates').catch(error => {});
				}*/

				//If user last update is more than 5 minutes old when checkForUpdates is called, call user update first
				if( (context.state.user.updated + 300000) < Date.now() ) {
					context.dispatch('checkForUserUpdates').then(response => {
						let curRoute = context.state.route;
						if(curRoute.meta.noauth) {
							if(curRoute.query.redirect) {
								router.push(curRoute.query.redirect);
							} else {
								router.push({name: 'account-trips'});
							}
						}
						context.dispatch('stopLoading');
					}, error => {});
				} else {
					let curRoute = context.state.route;
					if(curRoute.meta.noauth) {
						if(curRoute.query.redirect) {
							router.push(curRoute.query.redirect);
						} else {
							router.push({name: 'account-trips'});
						}
					} 
					context.dispatch('stopLoading');
				}
			} else {
				context.dispatch('deauthorize');
			}
		},
		checkForUserUpdates ( context ) {
			return new Promise((resolve,reject) => {
				
				http.get('users/' + context.getters.user.id + '?expand=fit,style')
					.then(response => {
						context.commit('setUser', response.data);
						resolve(response.data);
					})
					.catch(error => {
						context.dispatch('deauthorize');
						reject(error);
					});
			});
		},
		/*checkForStyleUpdates ( context ) {
			return new Promise((resolve,reject) => {
				
				http.get('users/' + context.getters.user.id + '/style')
					.then(response => {
						context.commit('setStyle', response.data);
						resolve(response.data);
					})
					.catch(error => {
						reject(error);
					});
			});
		},
		checkForFitUpdates ( context ) {
			return new Promise((resolve,reject) => {
				
				http.get('users/' + context.getters.user.id + '/fit')
					.then(response => {
						context.commit('setFit', response.data);
						resolve(response.data);
					})
					.catch(error => {
						reject(error);
					});
			});
		},*/
		
		updateStyle: function( context, style ) {
			context.commit( 'setStyle', style );
		},
		updateFit: function( context, fit ) {
			context.commit( 'setFit', fit );
		}
	},
	mutations: {
		updateAccessToken ( state, token ) {
			state.access_token = (!token ? false : token);
			//Vue.http.headers.common['Authorization'] = (token ? 'Basic ' + btoa(state.access_token + ':*') : '');
		},
		setUser (state, user) {
			state.user.updated = (!user ? 0 : Date.now());

			if(user) {
				//Clean up Fit and Style meta into arrays
				let fit
			}

			state.user.data = (!user ? {} : user);
		},
		setReferredBy (state, referred) {
			if(!referred) {
				state.referred_by = null;
			} else {
				state.referred_by = referred + '+' + (Date.now() + (1000 * 60 * 60 * 24 * 3));
			}
		},
		setStyle (state, style) {
			if(state.user.data.id) {
				if(!style) {
					state.user.data.style = {};
				} else {
					let keys = Object.keys(style);
					for(let key of keys) {
						let allSelected = true;
						let hasNoPref = false;
						let noneSelected = true;
						let hasNone = false;
						for(let i = 0; i < styleOptions[ key ].length; i++) {
							let opt = styleOptions[key][i];
							if(opt.key == 'no_preference') {
								hasNoPref = true;
							} else if(opt.key == 'none') {
								hasNone = true;
							} else {
								if(style[key].indexOf(opt.key) < 0) {
									allSelected = false;
								} else {
									noneSelected = false;
								}
							}
						}

						if(hasNone && noneSelected) {
							style[key] = ['none'];
						} else 
						if(hasNoPref && allSelected) {
							style[key] = ['no_preference'];
						}
					}
					state.user.data.style = style;
				}
			}
		},
		/*setStyle (state, style) {
			if(!style || style._id == null) {
				state.style = {
					updated: 0,
					data: JSON.parse(JSON.stringify(styleDefault))
				}
			} else {
				state.style.updated = Date.now();
				
				//Change any options with no_preference TO no_preference if all other options are selected
				for(let i = 0; i < Object.keys(styleOptions).length; i++) {
					let key = Object.keys(styleOptions)[i];
					if(typeof style[key] === 'undefined') continue;
					
					let style_option = styleOptions[key];
					let no_pref_option = false;
					let all_selected = true;
					for(let i2 = 0; i2 < style_option.length; i2++) {
						if(style_option[i2].key != 'no_preference') {
							if(style[key].indexOf(style_option[i2].key) >= 0) continue;
							all_selected = false;
						} else {
							no_pref_option = true;
						}
					}

					if(no_pref_option && all_selected) {
						style[key] = ['no_preference'];
					}
				}

				state.style.data = { ...state.style.data, ...style };
			}
		},*/
		setFit (state, fit) {
			if(state.user.data.id) {
				state.user.data.fit = (fit ? fit : {});
			}
		},
		setLoading (state, loading) {
			state.loading = (loading ? true : false);
		},
		setWizardVisible (state, vis) {
			state.wizardNavigator.show = (vis ? true : false);
		},
		setWizardNextDisabled (state, next) {
			state.wizardNavigator.nextDisabled = (next ? true : false);
		},
		setWizardPrevDisabled (state, prev) {
			state.wizardNavigator.prevDisabled = (prev ? true : false);
		},
		setWizardItemsRemaining (state, item) {
			state.wizardNavigator.itemsRemaining = (item || 0);
		},
		setWizardProgressStep (state, step) {
			switch(step) {
				case 'style':
				case 'size':
				case 'lookbook':
				case 'checkout':
					state.wizardNavigator.progressStep = step;
					break;
				case 'trip':
				default:
					state.wizardNavigator.progressStep = 'trip';
					break;
			}
		},
		hideWizardSizeStyle ( state ) {
			state.wizardNavigator.showSizeAndStyle = false;
		},
		showWizardSizeStyle ( state ) {
			state.wizardNavigator.showSizeAndStyle = true;
		},
		setWizardHasLookbook ( state, has ) {
			state.wizardNavigator.hasLookbook = (has ? true : false);
		},

		setOrderCache ( state, order ) {
			if(!order || !order._id) return;
			state.cache.orders[ order._id ] = {
				data: order,
				updated: Date.now()
			}
		},
		setLookbookCache ( state, lookbook ) {
			if(!lookbook || !lookbook._id) return;
			state.cache.lookbooks[ lookbook._id ] = {
				data: lookbook,
				updated: Date.now()
			}
		},

		resetCaches( state ) {
      state.cache = JSON.parse(JSON.stringify(cache));
			state.wizardNavigator = JSON.parse(JSON.stringify(wizardNavigator));
		},
		setOauthRedirect (state, url) {
			state.oauth_redirect = url;
		}
	}
});

export default store;
